import env from '@polleverywhere/core/lib/env'

function generateUrl (path) {
  return env.get('api_url').path(path).toString()
}

export const SUPPORT_URL = 'https://www.polleverywhere.com/8ru5cb/webex/getting-started'

export const LINKS = {
  guide: {
    url: SUPPORT_URL,
    iconName: 'pop-out',
    text: 'Getting started guide'
  },
  support: {
    url: SUPPORT_URL,
    iconName: 'support',
    text: 'Support'
  },
  present: {
    url: generateUrl('activities'),
    iconName: 'pop-out',
    text: 'Choose an activity to present'
  },
  activities: {
    url: generateUrl('activities'),
    iconName: 'activities',
    text: 'Go to activities'
  },
  logout: {
    iconName: 'exit',
    text: 'Log out'
  }
}

export const ICONS = {
  multiple_choice_poll: 'multiple-choice',
  free_text_poll: 'open-ended',
  clickable_image: 'clickable-image',
  ranking_poll: 'ranking',
  discourse: 'q-and-a',
  survey: 'survey',
  competition: 'competition'
}
